import React, { useEffect, useState } from 'react'
import jwt from 'jwt-decode'
import Layout from '../layouts/centered'
import CenteredForm from '../layouts/centered-form'
import { Alert } from '../components/alerts'
import { userService } from '../functions/services/user.service'
import { history, resolveCallback } from '../functions/_helpers'

const DEFAULT_REDIRECT = '/mobile/dashboard';
const DRIVER_REDIRECT = '/mobile/dashboard';
// Role 3 = driver (confirmed by role checks in WorkShiftController/MyTripsController on the backend).
const DRIVER_ROLE = 3;

const SsoLogin = () => {
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');
        const callback = resolveCallback(params.get('callback'));

        if (!token) {
            setIsLoading(false);
            setError('Mangler token i url.');
            return;
        }

        userService.ssoLogin(token)
            .then(user => {
                if (user && user.token) {
                    if (callback) {
                        history.push(callback.path);
                    } else {
                        let role = null;
                        try {
                            role = parseInt(jwt(user.token).role);
                        } catch {
                            role = null;
                        }
                        history.push(role === DRIVER_ROLE ? DRIVER_REDIRECT : DEFAULT_REDIRECT);
                    }
                } else {
                    setIsLoading(false);
                    setError('Innlogging feilet. Ugyldig eller utløpt lenke.');
                }
            })
            .catch(() => {
                setIsLoading(false);
                setError('Innlogging feilet. Ugyldig eller utløpt lenke.');
            });
    }, []);

    return (
        <Layout>
            <CenteredForm>
                {isLoading && !error && (
                    <div className="w-full text-center">Logger inn...</div>
                )}
                {error && (
                    <div className="w-full mb-4">
                        <Alert
                            color="bg-transparent border-red-500 text-red-500"
                            borderLeft
                            raised>
                            {error}
                        </Alert>
                    </div>
                )}
            </CenteredForm>
        </Layout>
    )
}

export default SsoLogin
